import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  TextField,
  List,
  ListItem,
} from '@material-ui/core';
import commonStyles from '../../../../styles';
import commonTheme from '../../../../styles/theme';

const useStyles = makeStyles((theme) => ({
  contentIpt: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#fff',
    border: '1px solid #C8C8C8',
    padding: '9px 8px',
    marginBottom: 8,
  },
  contentIpt2: {
    padding: '5px 8px 4px',
  },
  contentIptLbl: {
    '& span': {
      color: '#D83420',
    },
  },
  contentIptVal5: {
    width: 320,
  },
  contentIptTxt: {
    width: '100%',
    '& > div::before': {
      [commonTheme.breakpoints.up('md')]: {
        borderBottom: '2px solid transparent',
      },
    },
    '& > div::after': {
      borderBottom: `2px solid ${theme.palette.primaryColor}`,
    },
    '& > div:hover:not(.Mui-disabled):before': {
      borderBottom: `2px solid ${theme.palette.primaryColor}`,
    },
    '& input': {
      fontFamily: 'Roboto',
      fontSize: 16,
      zoom: 0.81,
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: 0,
      color: '#333',
      [commonTheme.breakpoints.up('md')]: {
        textAlign: 'right',
      },
    },
    '& textarea': {
      fontFamily: 'Roboto',
      fontSize: 16,
      zoom: 0.81,
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: 0,
      color: '#333',
    },
    '& > div': {
      margin: 0,
    },
  },
  // SP
  list: {
    background: '#fff',
    padding: '0 0 0 16px',
    marginBottom: 4,
  },
  listItem: {
    padding: 0,
  },
}));

export default function RegisterWindowDate(props) {
  const {
    subject,
    setSubject,
    getParts,
    getEditDialog,
  } = props;

  const classes = useStyles();
  const baseClasses = commonStyles();

  // モーダル用
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // SP・PCでの分岐用
  const windowWidth = window.innerWidth;
  const breakPoint = 768;
  const isSP = (windowWidth < breakPoint);
  let contents;

  // SP フォーカスが外れた時に値を退避
  const onBlur = (e) => {
    setSubject(e.target.value);
  };

  const getSubject = () => {
    return (
      <TextField
        className={classes.contentIptTxt}
        defaultValue={subject}
        onBlur={onBlur}
        placeholder="-"
      />
    );
  };

  const list = [
    {
      type1: 'noModal',
      type2: 'text',
      lbl: '件名',
      click: handleOpen,
      val: subject,
      opn: open,
      onClose: handleClose,
      content: getSubject,
    },
  ];

  if (isSP) {
    contents = (
      <Grid>
        <List className={classes.list}>
          {list.map((item) => {
            return (
              <ListItem
                key={item.lbl}
                className={classes.listItem}
              >
                {getParts(item)}
                {getEditDialog(item)}
              </ListItem>
            );
          })}
        </List>
      </Grid>
    );
  } else {
    contents = (
      <Grid className={`${classes.contentIpt} ${classes.contentIpt2}`}>
        <Typography
          className={`${baseClasses.title6} ${classes.contentIptLbl}`}
        >
          件名
        </Typography>
        <Grid className={classes.contentIptVal5}>
          {getSubject()}
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid>
      {contents}
    </Grid>
  );
}
